import React from 'react';
import DocTypeWrapper from './DocTypeWrapper';
import { InlineHighlight } from './InlineTypeHighlight';
import { tsFunctionExpression } from './utils/tsDocTypeExpression';
export default function TsDocFunctionSignature(_ref) {
  var definition = _ref.definition,
      _ref$arrowStyle = _ref.arrowStyle,
      arrowStyle = _ref$arrowStyle === void 0 ? true : _ref$arrowStyle,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? true : _ref$compact;
  var def = tsFunctionExpression(definition, {
    arrowStyle: arrowStyle,
    compact: compact
  });
  return def ? /*#__PURE__*/React.createElement(DocTypeWrapper, null, /*#__PURE__*/React.createElement(InlineHighlight, {
    code: def
  })) : null;
}